type SignupSuccessStateProps = {
  title: string
  description: string
  loginCtaLabel: string
  homeCtaLabel: string
  onGoToLogin: () => void
  onGoToHome: () => void
}

export const SignupSuccessState = ({
  title,
  description,
  loginCtaLabel,
  homeCtaLabel,
  onGoToLogin,
  onGoToHome,
}: SignupSuccessStateProps) => (
  <section
    role="status"
    className="space-y-6 rounded-xl border border-[color-mix(in_srgb,var(--color-border-default)_82%,transparent)] bg-(--color-bg-card) p-6"
  >
    <div className="space-y-3">
      <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-[color-mix(in_srgb,var(--color-status-success)_16%,transparent)] text-(--color-status-success)">
        <svg viewBox="0 0 20 20" className="h-5 w-5 fill-none stroke-current stroke-[2.2]" aria-hidden>
          <path d="m4.5 10.5 3.5 3.5 7-7" />
        </svg>
      </span>
      <h2 className="text-2xl font-semibold tracking-tight text-(--color-text-primary)">{title}</h2>
      <p className="max-w-[46ch] text-sm leading-relaxed text-(--color-text-secondary)">{description}</p>
    </div>
    <div className="grid gap-2.5 sm:grid-cols-2">
      <button
        type="button"
        onClick={onGoToLogin}
        className="ca-btn-primary inline-flex h-11 items-center justify-center rounded-lg px-4 text-sm font-semibold"
      >
        {loginCtaLabel}
      </button>
      <button
        type="button"
        onClick={onGoToHome}
        className="ca-btn-secondary inline-flex h-11 items-center justify-center rounded-lg border border-(--color-border-default) px-4 text-sm font-semibold text-(--color-text-secondary)"
      >
        {homeCtaLabel}
      </button>
    </div>
  </section>
)
